import React from 'react'

export const SectionB = () => {
    return (
        <>
            <section className="section-2">
                <h1><b>01.</b> ABOUT</h1>
                <p>Hey! I’m <u>lokesh kumar</u> , a web developer.</p>
                <p>
                    I’m a software engineer who loves creating websites and apps. I believe that you have to be able to see
                    the big picture when you’re building something, and that’s why I like to work with a team. It’s also why
                    I love working in groups where everyone has a voice, but we all work together toward the same goal—to
                    make your site better than you could ever do on your own.
                    You can find me playing video games or watching TV shows when I’m not working on my projects or building
                    excellent new tools for my clients.
                </p>
                <p>You can find me playing video games or watching TV shows when I’m not working on my projects or building
                    excellent new tools for my clients.</p>
            </section>
        </>
    )
}
